var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.6 3.69994C44.6 3.69994 41.8 0.299945 36.9 0.499945C31.1 0.699945 25.7 4.19994 26.3 13.2999C26.3 13.2999 17.6 15.9999 3.9 2.99994C3.9 2.99994 -0.499997 10.0999 7.3 16.8999C7.3 16.8999 5.1 17.4999 2.2 15.8999C2.2 15.8999 0.599998 21.8999 10.6 26.4999C10.6 26.4999 7.2 27.4999 5.7 26.4999C5.7 26.4999 6.6 32.8999 15.5 34.3999C15.5 34.3999 10.9 38.9999 0 38.7999C0 38.7999 22.6 50.3999 38.3 35.4999C49.5 24.8999 47.9 10.6999 47.9 10.6999C47.9 10.6999 51.2 9.69995 53.2 6.09995C53.2 6.09995 49.5 7.29994 47.3 7.09995C47.3 7.09995 51.4 4.49994 51.7 1.49994C51.9 1.49994 48.4 3.99994 44.6 3.69994Z"}));
}

Twitter.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 54 44"};

module.exports = Twitter;

Twitter.default = Twitter;
